<template>
    <div class="ui-sidebar-tabs" v-if="tabs">
        <div ref="ui-tabs-buttons">
            <div ref="ui-tabs-buttons-content">
                <button v-for="tab in tabs"
                    :key="tab.id"
                    :ref="'tab-' + tab.id"
                    type="button"
                    @click="openContent(tab.id)">
                    {{tab.label}}
                </button>
            </div>
        </div>
        <div>
            <button type="button" @mousedown="tabsScrollRight">
                <i class="fal fa-angle-left"></i>
            </button>
            <button type="button" @mousedown="tabsScrollLeft">
                <i class="fal fa-angle-right"></i>
            </button>
        </div>
    </div>
</template>

<script>
	export default {
        props: {
            tabs: {
                type: Array,
                required: false,
            },
            current: {
                type: String,
                required: false,
            }
        },
		data(){
			return {
                status: false,
                tabCurrent: 0
            }
        },
        methods: {
            tabsScrollLeft(){
                this.$refs['ui-tabs-buttons'].scrollLeft += 150;
            },
            tabsScrollRight(){
                this.$refs['ui-tabs-buttons'].scrollLeft -= 150;
            },
            openContent(id){
                this.$parent.$emit('tab-content', id)
            },
            setTabActive(id){
                
                if(!this.tabs || !id) return false
                
                let tabs = this.$refs['ui-tabs-buttons'].querySelectorAll('button')
                for(let i = 0; i < tabs.length; i++){
                    tabs[i].classList.remove('active')
                }
                this.$refs['tab-'+id][0].classList.add('active')

                this.prepareTabs()

                let t = setTimeout( () => {
                    this.$refs['ui-tabs-buttons'].scrollLeft = this.$refs['tab-'+id][0].offsetLeft 
                    clearInterval(t)
                },10)

            },
            prepareTabs(){
                if(this.tabs){
                    let tabs = this.$refs['ui-tabs-buttons'].querySelectorAll('button')
                    let width = 0;
                    for(let i = 0; i < tabs.length; i++){
                        width += tabs[i].offsetWidth
                    }
                    this.$refs['ui-tabs-buttons-content'].style.width = width+'px'
                }
            }
        },
        created(){
            this.$parent.$on('tab-active', id => {
                this.setTabActive(id)
            })
        },
        mounted(){
            this.prepareTabs()
        }
	}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>